import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Platform } from '@ionic/angular';
import { BaseHelper } from './baseHelper';
import { AuthService } from 'src/services/auth.service';
import { GlobalProvider } from 'src/services/global';
import { SharedModule } from './components/shared.module';
import { MenuHelper } from './menuHelper';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, SidebarComponent, RouterOutlet, CommonModule, SharedModule],
})
export class AppComponent {
  rootPath = '/dashboard';
  constructor(
    private router: Router,
    private platform: Platform,
    private b: BaseHelper,
    private authAPI: AuthService,
    public g: GlobalProvider,
    private menuhelper: MenuHelper,
    private cd: ChangeDetectorRef
  ) {
    this.initializeApp();
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Handle page change event
        console.log('Page changed:', event.url);
        this.b.setStorage('page', event.url);
        // You can perform actions here, such as updating page-specific data or analytics tracking
      }
    });
  }

  isLoginPage(): boolean {
    return this.router.url === '/login';
  }

  async initializeApp() {
    this.g.menuReady = false;
    const savedToken = this.b.getStorage('companyToken');
    if (savedToken) {
      this.g.jws = 'Bearer ' + savedToken;
    }
    this.platform.ready().then(async () => {
      this.b.menuClose();
      // this.getGeneralInfo();
      const urlParams = new URLSearchParams(window.location.search);

      const resetToken = urlParams.get('resetToken');
      if (resetToken) {
      } else {
        console.log(`this.router.url?`, this.router.url);
        // if (`/login` === this.router.url || `/` === this.router.url) {
        //   console.log(`enter login`);
        //   this.g.loadingJwt = false;
        //   // this.b.navigateRoot(`/customer`);
        //   return;
        // } else if (`/login/admin` === this.router.url) {
        //   this.g.loadingJwt = false;
        //   // this.b.navigateRoot(`/customer`);
        //   return;
        // }
        const tokenObj = await this.b.getJws();
        if (tokenObj && tokenObj) {
          console.log(`tokenObj?`, tokenObj);
          const { profileType } = tokenObj;
          const result = await (
            await this.authAPI.loginViaToken('Bearer ' + tokenObj)
          )
            .toPromise()
            .catch((err) => {
              return Promise.resolve(null);
            });

          console.log('resulttokenObj', result);
          await this.checkVersion();
          if (!result) {
            this.g.loadingJwt = false;
            this.b.clearJws();
            // return this.b.navigateRoot(defaultRoot);
          }
          const r: any = result;
          console.log(`wht is r?`, r.profile);
          this.b.setJws(tokenObj, r.profile, r.mediaUrl, r.config);
          this.b.loadLoading(false);
          this.g.loadingJwt = false;
          if (
            (this?.g?.profile?.accessType === 'merchant' &&
              !this?.g?.profile?.accessRole &&
              this?.g?.profile?.role === 'admin') ||
            this?.g?.profile?.accessType === 'staff'
          ) {
            console.log('status?', 'merchant admin');
            this.menuhelper.setVisibleMenuItems([
              '/dashboard',
              '/banner',
              '/gps',
              '/campaign',
              '/coupon',
              '/accessRole-list',
              '/business-manage-listing',
              '/transaction-listing',
            ]);
            // this.menuhelper.shouldShowMenuItem()
            this.cd.detectChanges();
          }
          if (
            (this?.g?.profile?.accessType === 'merchant' &&
              this?.g?.profile?.accessRole &&
              this?.g?.profile?.role === 'admin') ||
            (this?.g?.profile?.accessType === 'staff' &&
              this?.g?.profile?.accessRole?.all === 0)
          ) {
            console.log('status?', 'merchant staff');
            // console.log("this.g.profile?", this.g.profile)
            const routes: string[] = Array.from(
              new Set<string>(
                this?.g?.profile?.accessRole.accessRoleRights
                  .map((item: any) => item.ns)
                  .filter((ns: unknown): ns is string => typeof ns === 'string')
              )
            );
            console.log('status?', 'merchant' + routes.length);
            this.menuhelper.setVisibleMenuItems(routes);
            // this.menuhelper.shouldShowMenuItem()
            this.cd.detectChanges();
          }
          if (this?.g?.profile?.accessType !== 'merchant') {
            console.log('status?', 'not merchant');
            console.log('status?', this?.g?.profile?.accessRole?.all);
            if (this?.g?.profile?.accessRole?.all === 0) {
              const routes: string[] = Array.from(
                new Set<string>(
                  this?.g?.profile?.accessRole.accessRoleRights
                    .map((item: any) => item.ns)
                    .filter(
                      (ns: unknown): ns is string => typeof ns === 'string'
                    )
                )
              );
              console.log('status?', 'merchant' + routes.length);
              this.menuhelper.setVisibleMenuItems(routes);
              // this.menuhelper.shouldShowMenuItem()
              this.cd.detectChanges();
            } else {
              this.menuhelper.setVisibleMenuItems([
                '/dashboard',
                '/coupon',
                '/banner',
                '/campaign',
                '/gps',
                '/business-listing',
                '/customer',
                '/membership',
                '/category',
                '/accessRole-list',
                '/advertisement',
                '/user-profile-listing',
                '/accessRole-list',
                '/interest-listing',
              ]);
            }
          }

          this.g.menuReady = true;
          this.cd.detectChanges();
          this.b.menuClose();
          console.log(`this.router.url huh?`, this.router.url);
          const prevPage: any = this.b.getStorage('page');
          
          if (prevPage == '/login' || this.router.url == '/login') {
            this.b.navigateRoot(`/${this.rootPath}`);
          }
        } else {
          // console.log(`this.router.url huh?`, this.router.url);
          this.g.loadingJwt = false;
          this.b.clearJws();
          // this.b.navigateRoot(defaultRoot);
        }
      }
    });
  }

  async checkVersion() {
    const result2: any = await (await this.authAPI.globalSetting())
      .toPromise()
      .catch((err) => {
        return Promise.resolve(null);
      });
    if (result2 && result2.detail) {
      console.log('result2.detail?', result2.detail);
      this.g.globalSetting = result2.detail;
    } else {
      console.log('result2 is null');
    }
  }
}
